import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect, Field, ErrorMessage } from 'formik'
import Button from 'antd/es/button'
import Typography from 'antd/es/typography'
import Select from 'antd/es/select'
import Input from 'antd/es/input'
import Icon from 'antd/es/icon'
import Spin from 'antd/es/spin'
import PhoneInput from 'react-phone-input-2'
import { triggerFormLevelValidation } from '../utils/formik.js'
import FieldLabel from '../partials/fieldLabel.jsx'
import CustomInputComponent from '../partials/formik/customInputComponent.jsx'
import '../styles/signUpForm.scss'
import { PRE_SIGNUP_SUBSCRIPTION_KEY, SEND_EMAIL_VERIFICATION_CODE_ENDPOINT, SLACK_ENDPOINT } from '../config/constants.js'
import 'react-phone-input-2/lib/style.css'
import PhoneInputComponent from '../partials/formik/PhoneInputComponent.jsx'
import { errorNotification } from '../utils/helpers.js'
import { postNotificationToSlackAPICall } from '../apis/slack.js'
import { sendEmailVerificationCodeAPICall } from '../apis/email-verification.js'

const { Paragraph } = Typography
const { Option } = Select

function SignUpForm({ history, formik }) {
  const [isSubmitting, setIsSubmitting] = useState(false)


  const signUp = () => {
    triggerFormLevelValidation(formik, async () => {
      // console.log('signUp', formik.values)
      const {
        name, email, phone, role
      } = formik.values

      const payload = {
        username: 'Physician Signup App',
        text: `A ${role} named ${name} signed up to view patient records. The user info is as follows: \nName: ${name}\nEmail: ${email}\nPhone: ${phone}`,
        icon_emoji: ':trophy:'
      }
      setIsSubmitting(true)
      await postNotificationToSlackAPICall({payload})
      setIsSubmitting(false)

      const responseOk = await sendEmailVerificationCodeAPICall(email)
      if(responseOk){
        history.push('/verification')
      } else{
        errorNotification('An error occured. Please try again.')
      }

    })
  }

  const antIcon = <Icon type="loading" style={{ fontSize: 24, color: '#fff' }} spin />

  return (
    <div className="sign-up-form">
      <FieldLabel label="Full Name" maxWidth={293}>
        <Field
          name="name"
          placeholder="insert name here"
          component={CustomInputComponent}
        />
      </FieldLabel>
      <FieldLabel label="Email Address" maxWidth={293}>
        <Field
          name="email"
          placeholder="insert email here"
          component={CustomInputComponent}
        />
      </FieldLabel>
      <FieldLabel label="Phone Number" maxWidth={293}>
      <Field
          name="phone"
          placeholder="insert phone number here"
          component={PhoneInputComponent}
        />
      </FieldLabel>
      <FieldLabel label="Role" maxWidth={293}>
        <Field
          name="role"
          render={({ field, form }) => (
            <Select
              {...field}
              style={{ width: '100%' }}
              placeholder="select a role"
              onChange={(value) => {
                form.setFieldValue('role', value)
              }}
            >
              <Option value="clinician">Clinician</Option>
              <Option value="administrator">Administrator</Option>
            </Select>
          )}
        />
      </FieldLabel>
      <FieldLabel label="Password" maxWidth={293}>
        <Field
          type="password"
          name="password"
          placeholder="password"
          component={CustomInputComponent}
        />
      </FieldLabel>
      <div className="sign-up-form-submit-btn">
        <Button
          disabled={isSubmitting}
          type="primary"
          onClick={signUp}
        >
          {isSubmitting ? <Spin indicator={antIcon} /> : 'Claim My Account'}
        </Button>
      </div>
      <div className="sign-up-form-terms-conditions">
        <Paragraph>
          By clicking "Claim My Account", I agree to the
          <a href="https://alemhealth.com/termsofservice" className="underline"> Terms {'&'} Conditions</a> of signing up.
        </Paragraph>
      </div>
    </div>
  )
}

SignUpForm.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  formik: PropTypes.object,
}

export default connect(withRouter(SignUpForm))
